export const types = {
   EXTRACTIMAGE: 'EXTRACT-IMAGE',

};